<template>
    <!-- Componente para mostrar los servicios de mantenimiento -->
    <div
        v-show="showServices"
        class="lg:flex lg:w-9/12 lg:mx-auto mt-4 sm:mt-6 lg:mt-4 lg:justify-between"
    >
        <div class="inspection w-10/12 sm:w-8/12 lg:w-1/2 lg:mr-6 mx-auto lg:mx-0 bg-white">
            <h3
                class="font-bold text-xl sm:text-2xl lg:text-xl text-center py-3 border-solid border-b border-light-gray">
                Inspección</h3>
            <div class="list w-8/12 sm:w-7/12 mx-auto pt-6 pb-8">
                <div class="overflow-y-auto h-56 sm:h-64 lg:h-48 text-base sm:text-lg lg:text-base leading-snug">
                    <p
                        v-for="(inspection, index) in serviceSelected.inspections"
                        :key="index"
                    >· {{ inspection }}</p>
                </div>
            </div>
        </div>
        <div class="change w-10/12 sm:w-8/12 lg:w-1/2 mx-auto lg:mx-0 bg-white mt-4 lg:mt-0">
            <h3
                class="font-bold text-xl sm:text-2xl lg:text-xl text-center py-3 border-solid border-b border-light-gray">
                Cambio</h3>
            <div class="list w-8/12 sm:w-7/12 mx-auto pt-6 pb-8">
                <div class="overflow-y-auto h-32 lg:h-48 sm:h-40 text-base sm:text-lg lg:text-base leading-snug">
                    <p
                        v-for="(change, index) in serviceSelected.changes"
                        :key="index"
                    >· {{ change }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['maintenanceServices'],
    data() {
        return {
            serviceSelected: {}
        }
    },
    computed: {
        showServices() {
            return !$.isEmptyObject(this.serviceSelected)
        }
    },
    created() {
        // Si se emite el evento correspondiente desde
        // el componente de ModelServices  muestra los servicios
        // de mantenimiento correspondientes
        this.$eventBus.$on('service-change', service => {
            this.serviceSelected = this.maintenanceServices.filter(item => item.service === service)[0]
        })
    },
    beforeDestroy() {
        this.$eventBus.$off('iframe-appointment-message')
    },
}
</script>

<style>

</style>